import type { ChemicalRouteEstimationContext } from "../../data/models/schemas";
import type { IUserState } from "../../redux/types/IUserState";
import { PROPERTIES_DATA_ESTIMATION_INLINE_ENABLED } from "./FeatureGates";

export const getInlineEstimationContext = (
    user?: IUserState
): ChemicalRouteEstimationContext | undefined =>
    PROPERTIES_DATA_ESTIMATION_INLINE_ENABLED(user)
        ? {
              runEstimation: true,
          }
        : undefined;
